import { Box } from '@mui/material';
import Spinner from 'components/Spinner/Spinner';
import PropTypes from 'prop-types';
/**
 * Root Component
 */
import React from 'react';
import { IntlProvider } from 'react-intl';
import { connect, Provider } from 'react-redux';
import { createBrowserRouter, createRoutesFromElements, RouterProvider } from 'react-router-dom';
import { getI18n } from './AppReducer';
import { isLoggedIn } from './modules/Auth/AuthReducer';

// Import Routes
import routes from './routes';

// Base stylesheet
import main from './main.css';
import slick from 'slick-carousel/slick/slick.css';
import slickTheme from 'slick-carousel/slick/slick-theme.css';
import searchkit from 'searchkit/theming/theme.scss';
import searchkitCss from './searchkit.css';
import reactFlexboxGrid from 'react-flexbox-grid/dist/react-flexbox-grid.css';

if (main || slick || slickTheme || searchkit || searchkitCss || reactFlexboxGrid) {
  // reference the css files to avoid them being removed by cssnano
}

function App(props) {
  return (
    <Provider store={props.store}>
      <IntlProvider
        locale={props.locale}
        messages={props.messages}
        key={`${props.locale}-${props.loggedIn}`}
      >
        <RouterProvider
          router={createBrowserRouter(createRoutesFromElements(routes(props.store)))}
          fallbackElement={
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
              <Spinner />
            </Box>
          }
        />
      </IntlProvider>
    </Provider>
  );
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    ...getI18n(state),
    loggedIn: isLoggedIn(state),
  };
}

App.defaultProps = {
  messages: null,
};

App.propTypes = {
  store: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  messages: PropTypes.object,
  loggedIn: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(App);
